var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('div',{class:_vm.classHeading},[_vm._v(" "+_vm._s(_vm.chartHeader)+" ")]),_vm._v(" "),_c('div',{ref:"pieChart",class:_vm.className,style:({height:_vm.height,width:_vm.width})})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47bdb1f6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PieChart.vue
// module id = null
// module chunks = 